import { useSelector } from 'react-redux';

import { AppState } from '../../../../../../app.types';

export function useSelectedProfilePicture () {
    return useSelector<AppState, string>((state: AppState) => {
        const profilePicture = state.profilePicture.data?.profilePicture;

        return profilePicture;
    });
}
